import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import { BreadcrumbItem, Breadcrumb, Select, MenuItem, MenuItemGroup, Submenu, Menu, Form, FormItem, Input, Button, Message, Container, Aside, Main, Header, Row, Col } from 'element-ui'
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Button)
Vue.use(Container)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Header)
Vue.use(Row)
Vue.use(Col)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(MenuItem)
Vue.use(Select)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.prototype.$message = Message
